import { Directive, HostListener, EventEmitter, Output, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { setNoInCatPos, setInCatPos } from '@app/modules/organization/store/actions/organization.actions';
import { selectNotInCatPos, selectInCatPos } from '@app/modules/organization/store/selectors/organization.selectors';
import { first, skipWhile, windowTime } from 'rxjs';


@Directive({
  selector: '[appScroll]'
})
export class ScrollDirective implements OnInit {
  public name$;

  constructor(
    private store$: Store,
    private el: ElementRef
  ) { 

  }

  ngOnInit(){
    this.store$.select(selectInCatPos).pipe(
      skipWhile(res => res == null),
      first()
      ).subscribe({
      next: res => {
        const els = document.querySelectorAll('.master-count__in-cat__item');
        let rect = document.getElementById('master-count__in-cat');

          for(let i = 0; i < els.length - 1; i++){
            if(els[i].textContent[0].toLowerCase() == res){
              rect.scroll(els[i].getBoundingClientRect().left, els[i].scrollTop);
            }
          }
      }
    })
  }

  @HostListener("scroll", ["$event"])
  onListenerTriggered(event: UIEvent): void {
    const top = this.el.nativeElement.getBoundingClientRect().top;
    const left = this.el.nativeElement.getBoundingClientRect().left;
    const el = document.elementFromPoint(left, top);
    if(el.classList.contains('cdk-drag')){
      this.store$.dispatch(setInCatPos({ posName: el.children[1].textContent.trim()[0].toLowerCase() }))
    }

  }
}
